module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-screen.5d9aa6a4.mp4";